import './NavBar.scss';
import { PiArrowLeftBold } from 'react-icons/pi';
import { useNavigate, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';

function NavBar() {
    const navigate = useNavigate();
    const location = useLocation();
    const [canGoBack, setCanGoBack] = useState(location.pathname === '/');

    useEffect(() => {
        setCanGoBack(location.pathname !== '/' && location.pathname !== '/unlock');
    }, [location.pathname])

    const handleNavigateBack = (ev) => {
        ev.preventDefault();
        navigate(-1);
    };

    const handleNavigateHome = (ev) => {
        ev.preventDefault();
        navigate('/');
    };

    return (
        <div className="navbar">
            <div className="navbar-inner">
                {((canGoBack && <div className="navbar-back" onClick={handleNavigateBack}>
                    <PiArrowLeftBold className="back-icon" />
                </div>) || <div></div>)}
                <div className="navbar-middle">
                    <img className="navbar-logo" src="/design.png" alt="Logo" onClick={handleNavigateHome}/>
                </div>
            </div>
        </div>
    );
}

export default NavBar;
